import React from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import SingleArticle from 'views/singleArticle';
import Layout from 'components/layout';
import { NavBar, PopupRedirect } from 'components';
import { pages } from 'config/pages';

const ArticlePage = ({ data }) => {
  const { markdownRemark: postData, allMarkdownRemark } = data;
  const page = pages.article;
  const { navColors } = page;

  const contributor = allMarkdownRemark.edges.find(
    edge =>
      edge.node.frontmatter.templateKey === 'contributor-page' &&
      edge.node.frontmatter.title === postData.frontmatter.contributor,
  ).node.frontmatter;

  const articleList = allMarkdownRemark.edges.filter(
    edge => edge.node.frontmatter.templateKey === 'article-page',
  );

  return (
    <Layout page={page}>
      <NavBar
        color={navColors}
        banner={{
          key: 'newsletter',
          newsletter: true,
        }}
      />
      <PopupRedirect message={'article'} />
      <SingleArticle
        post={postData}
        postList={articleList}
        contributor={contributor}
        allArticles={allMarkdownRemark}
      />
    </Layout>
  );
};

ArticlePage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }).isRequired,
};

export default ArticlePage;

export const pageQuery = graphql`
  query BlogPostByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      fields {
        slug
      }
      frontmatter {
        title
        cover
        tags
        lead
        content {
          body
          fullwidthImage {
            image
            alt
            comment
          }
        }
        settings {
          date
          category
          metaDescription
          metaTitle
          related {
            title
          }
          slug
          canonical
        }
        contributor
        mainContent {
          related {
            title
          }
        }
      }
    }
    allMarkdownRemark(
      sort: { order: ASC, fields: [frontmatter___settings___date] }
    ) {
      edges {
        node {
          excerpt(pruneLength: 400)
          id
          fields {
            slug
          }
          frontmatter {
            title
            job
            photo
            cover
            templateKey
            settings {
              date(formatString: "MMMM DD, YYYY")
              slug
              type
              category
            }
            contributor
            box {
              content {
                title
                tags
                clientLogo
                coverImage
              }
              settings {
                tileColor
                textColor
                link
              }
              type
            }
          }
        }
      }
    }
  }
`;
